<template>
  <Button
    class="size-control shrink-0 !p-0"
    @click="emit('onToggle')"
  >
    <Icon
      class="m-auto"
      name="bars"
      :width="14"
      :height="14"
    />
  </Button>
</template>

<script setup lang='ts'>
import Button from 'primevue/button';

import Icon from '@/common/components/atoms/Icon';

const emit = defineEmits<{
  onToggle: []
}>();
</script>


